/**This file contains a constant object that has properties that are necessary
 * for the build found in the `development` configuration in `angular.json`.
 */
export const environment = {
	environment: 'qa',
	production: false,
	financialUrl: 'https://api-qat.mss.ford.com/api-sacim-ext/gcp3/api/v1/sacim', // TODO: remove "/gcp3" after GCS URI test
	baseUrl: '',
	samisToken: 'd8da212f',
	apsDescription: 'SACIM',
	country: 'BRA',
	tlkUrl: 'https://api-qat.mss.ford.com/api-sacim-ext/gcp3/api/v1/tlk',
	msalConfig: {
		clientId: '475520b9-b77b-4016-b10e-604ddc80afbe',
		authority:
			'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0/',
		redirectUri: 'https://gcp3test.creditlimit.ford.com/', // TODO: remove after GCS URI test
	},
	apiConfig: {
		scopes: ['api://492fba01-afdc-4164-929f-8129a66f8134/.default'],
		uri: 'https://api-qat.mss.ford.com/api-sacim-ext/gcp3/api/v1/sacim', // TODO: remove "/gcp3" after GCS URI test
	},
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
